import {dopeActionButtonTemplateResolveProps, DoppeTemplateInstance} from "../../doppe-sdk";
import {DoppeActionButtonTemplateIds} from "./doppe-templates";
import {
    DopeStandardActionButtonSkin, DoppeStandardActionButtonHoverAnimation,
    DoppeStandardActionButtonTemplateMetadata
} from "../../components/doppe-action-button-templates/doppe-standard-action-button-template/doppe-standard-action-button-template.metadata";

export function doppeActionButtonTemplateInstanceHasShadow (
    actionButtonTemplateInstance: DoppeTemplateInstance
) {
    if (actionButtonTemplateInstance.templateId === DoppeActionButtonTemplateIds.Standard) {

        const templateProps = dopeActionButtonTemplateResolveProps(
            DoppeStandardActionButtonTemplateMetadata,
            actionButtonTemplateInstance.templateProps)

        switch (templateProps.skin) {
            case DopeStandardActionButtonSkin.HardShadow: return true;
            default: return false;
        }
    }

    return false;
}

export function doppeActionButtonTemplateInstanceHasTransparentBackground (
    actionButtonTemplateInstance: DoppeTemplateInstance
) {
    if (actionButtonTemplateInstance.templateId === DoppeActionButtonTemplateIds.Standard) {
        const templateProps = dopeActionButtonTemplateResolveProps(
            DoppeStandardActionButtonTemplateMetadata,
            actionButtonTemplateInstance.templateProps)

        switch (templateProps.skin) {
            case DopeStandardActionButtonSkin.Inverted: return true;
            default: return false;
        }
    }

    return false;
}

export function doppeActionButtonTemplateInstanceIsPremium (
    actionButtonTemplateInstance: DoppeTemplateInstance
) {
    if (actionButtonTemplateInstance.templateId === DoppeActionButtonTemplateIds.Standard) {
        const templateProps = dopeActionButtonTemplateResolveProps(
            DoppeStandardActionButtonTemplateMetadata,
            actionButtonTemplateInstance.templateProps)

        switch (templateProps.skin) {
            case DopeStandardActionButtonSkin.Gradient:
            case DopeStandardActionButtonSkin.Glass: {
                return true;
            }
            default: return false;
        }
    }

    return false;
}

export function doppeActionButtonTemplateGetDefault () {
    return {
        templateId: DoppeActionButtonTemplateIds.Standard,
        templateProps: {
            roundness: 0,
            skin: DopeStandardActionButtonSkin.Standard,
            hoverAnimation: DoppeStandardActionButtonHoverAnimation.None
        }
    }
}